import { router, setPageContent } from "..";
import { postUser } from "../api/users";
import { config } from "../app-env/common";
import { errorSection } from "../error-section";
import { loadingScreen } from "../loading-screen";
import { t } from "../locale";
import { Bulma } from "../view/bulma";
import { centeredBox, countrySelect, passwordInput } from "../view/components";

function createAccountPage() {
	const email = Bulma.input({
		type: "email",
	});

	const password = passwordInput();

	const country = countrySelect();

	const name = Bulma.input({
		type: "text",
	});

	const addr1 = Bulma.input({
		type: "text",
	});

	const addr2 = Bulma.input({
		type: "text",
	});

	const postalCode = Bulma.input({
		type: "text",
	});

	const town = Bulma.input({
		type: "text",
	});

	const vatin = Bulma.input({
		type: "text",
	});

	const onClickCreateAccount = () => {
		const attempt = errorSection.attempt(async () => {
			await postUser({
				email: email.getValue(),
				password: password.getValue(),
				country: country.getValue(),
				name: name.getValue(),
				addr1: addr1.getValue(),
				addr2: addr2.getValue(),
				postalCode: postalCode.getValue(),
				town: town.getValue(),
				vatin: vatin.getValue(),
			});

			if (config.appId === "test.my.luda.farm") {
				router.jump("/sign-in");
			} else {
				router.jump(`/verify-account?email=${email.getValue()}`);
			}
		});
		loadingScreen.waitFor(attempt);
	};

	setPageContent(
		centeredBox(
			"small",
			Bulma.title(t.createAccount),
			document.createElement("hr"),

			Bulma.title(t.accountCreationStep1, "is-6"),
			Bulma.field(
				{},
				Bulma.label(t.email),
				Bulma.control({}, email.element),
			),
			Bulma.field({}, Bulma.label(t.password), password.element),
			Bulma.field(
				{},
				Bulma.label(t.country),
				Bulma.control({}, country.element),
			),
			document.createElement("hr"),

			Bulma.title(t.accountCreationStep2, "is-6"),
			Bulma.field(
				{},
				Bulma.label(t.name),
				Bulma.control({}, name.element),
			),
			Bulma.field(
				{},
				Bulma.label(t.addressLine1),
				Bulma.control({}, addr1.element),
			),
			Bulma.field(
				{},
				Bulma.label(t.addressLine2),
				Bulma.control({}, addr2.element),
			),
			Bulma.field(
				{},
				Bulma.label(t.postalCode),
				Bulma.control({}, postalCode.element),
			),
			Bulma.field(
				{},
				Bulma.label(t.town),
				Bulma.control({}, town.element),
			),
			Bulma.field(
				{},
				Bulma.label(t.vatId),
				Bulma.control({}, vatin.element),
			),
			document.createElement("hr"),

			Bulma.buttons(
				Bulma.button(
					{
						onClick: onClickCreateAccount,
						styles: ["is-primary"],
					},
					t.createAccount,
				),
				Bulma.button(
					{
						onClick: () => router.jump("/sign-in"),
						styles: ["is-primary"],
					},
					t.cancel,
				),
			),
		),
	);
}

export { createAccountPage };
